import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import { useSnackbar } from "notistack";
import { Paper } from "@material-ui/core";
import { getProjectCierre } from "../../services/projectFileServices";
import "react-dropzone-uploader/dist/styles.css";

const PanelFilesActaCierreI = ({ projectSlug, projectId }) => {
  //const apiEndPoint = process.env.REACT_APP_API_URL;
  //const { enqueueSnackbar } = useSnackbar();

  //ACTA DE CIERRE

  let [cierre, setCierre] = useState(null);

  // specify upload params and url for your files

  const handleOpenPDFC = (event) => {
    event.preventDefault();
    if (cierre !== null) window.open(cierre);
  };

  useEffect(() => {
    const populateCierre = async () => {
      const { data: project } = await getProjectCierre(projectSlug);
      setCierre(project.cierre);
    };

    populateCierre();
  }, [projectSlug]);

  return (
    <>
      <Paper className="paper">
        <h2>Acta de Cierre: </h2>

        {cierre === null ? (
          "No existe ningun archivo"
        ) : (
          <Link to="#" onClick={handleOpenPDFC}>
            {cierre === null ? " " : "Abrir Acta de Cierre"}
          </Link>
        )}
      </Paper>
    </>
  );
};

export default PanelFilesActaCierreI;
